import { ANALYTICS_EVENTS } from './event-names.constants';

export interface EventRoutingRule {
  providers: string[];
}

export const EVENT_ROUTING_RULES: Record<string, EventRoutingRule> = {
  // Authentication Events
  [ANALYTICS_EVENTS.AUTH.LOGIN_PAGE_VISIT]: {
    providers: ['posthog', 'moengage']
  },
  [ANALYTICS_EVENTS.AUTH.PHONE_NUMBER_ENTERED]: {
    providers: ['posthog', 'moengage']
  },
  [ANALYTICS_EVENTS.AUTH.OTP_TRIGGERED]: {
    providers: ['posthog', 'moengage']
  },
  [ANALYTICS_EVENTS.AUTH.OTP_ENTERED]: {
    providers: ['posthog', 'moengage']
  },
  [ANALYTICS_EVENTS.AUTH.SIGN_UP]: {
    providers: ['posthog', 'moengage']
  },
  [ANALYTICS_EVENTS.AUTH.SIGN_IN]: {
    providers: ['posthog', 'moengage']
  },
};

// Default routing for unknown events
export const DEFAULT_EVENT_ROUTING: EventRoutingRule = {
  providers: ['posthog']
};

// Provider-specific routing rules
export const PROVIDER_ROUTING_RULES = {
  posthog: {
    enabled: true
  },
  moengage: {
    enabled: true
  }
};

// Helper functions
export function getEventRouting(eventName: string): EventRoutingRule {
  return EVENT_ROUTING_RULES[eventName] || DEFAULT_EVENT_ROUTING;
}

export function getProviderRouting(providerName: string) {
  return PROVIDER_ROUTING_RULES[providerName as keyof typeof PROVIDER_ROUTING_RULES];
} 